import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TenantAppUrl } from '../shared/interfaces/tenant-app-url.interface';
import { TenantConfiguration } from '../shared/interfaces/tenantConfiguration.interface';


@Injectable({
    providedIn: 'root'
})
export class TenantService {
    baseUri = environment.TENANT_BASE;
    baseUriPortal = environment.TENANT_PORTAL_BASE;

    constructor(private http: HttpClient) {
    }

    getTenantConfigurationsByDomain(domain: string): Observable<TenantConfiguration> {
        return this.http.get<TenantConfiguration>(`${this.baseUri}/domain/${domain}/configurations`).pipe(
            tap()
        )
    }

    getTenantAppUrlByTenantId(tenantId: number): Observable<TenantAppUrl> {
        return this.http.get<TenantAppUrl>(`${this.baseUriPortal}/${tenantId}/app-urls`)
    };
}